// Client-side inspect deterrent for the player app. Blocks the context menu and
// the common devtools shortcuts (F12, Ctrl/Cmd+Shift+I/J/C, Ctrl+U) in
// production.
//
// ponytail: deterrent ONLY, not security. A determined user bypasses any of this
// (disable JS, use a proxy, curl, view-source). Real protection is server-side —
// auth, tenant scoping, signed webhooks — which we already have. Keep it in one
// place; don't grow it into a devtools-detection arms race that never wins.
if (import.meta.env.PROD) {
  document.addEventListener('contextmenu', e => e.preventDefault());
  document.addEventListener('keydown', e => {
    const k = e.key.toLowerCase();
    const devtools =
      e.key === 'F12' ||
      ((e.ctrlKey || e.metaKey) && e.shiftKey && (k === 'i' || k === 'j' || k === 'c')) ||
      (e.ctrlKey && k === 'u');
    if (devtools) e.preventDefault();
  });
}
